import type { BadgeProps } from '@smiledragon-corp/sds-system';
import { Badge as SDBadge } from '@smiledragon-corp/sds-system/components';
import type { ColorStyledProps } from '@smiledragon-corp/sds-system/types';

type ColorVariantValue = 'red' | 'gray' | 'green' | 'blue' | 'yellow' | 'yellowFill' | 'danger';

const colorVariants: Record<ColorVariantValue, ColorStyledProps> = {
  blue: {
    bgColor: 'bg.infoSubtle',
    color: 'text.info',
  },
  danger: {
    bgColor: 'bg.dangerSubtle',
    color: 'text.danger',
  },
  gray: {
    bgColor: 'bg.tertiary',
    color: 'text.tertiary',
  },
  green: {
    bgColor: 'bg.successSubtle',
    color: 'text.success',
  },
  red: {
    bgColor: 'bg.errorSubtle',
    color: 'text.error',
  },
  yellow: {
    bgColor: 'bg.pointSubtle',
    color: 'text.point',
  },
  yellowFill: {
    bgColor: 'bg.point',
    color: 'text.primaryInverse',
  },
};

export const Badge = (props: BadgeProps & { colorVariant?: ColorVariantValue }) => {
  const { colorVariant, ...badgeProps } = props;
  return <SDBadge {...badgeProps} {...(colorVariant && colorVariants[colorVariant])} />;
};
